import {createInput, defaultConfig} from '@formkit/vue';
import { rootClasses } from './formkit.theme';
import { genesisIcons } from '@formkit/icons';
// import { colorpicker, createProPlugin, datepicker, dropdown, autocomplete, toggle, togglebuttons, taglist } from '@formkit/pro';

// const proPlugin = createProPlugin(import.meta.env.VITE_FORMKIT_KEY, {
//     colorpicker,
//     datepicker,
//     dropdown,
//     autocomplete,
//     toggle,
//     togglebuttons,
//     taglist,
// });

export default defaultConfig({
    config: {
        rootClasses,
    },
    icons: {
        ...genesisIcons,
    },
    plugins: [],
    inputs: {
    }
});
